import { render, staticRenderFns } from "./commerce-setup.vue?vue&type=template&id=26cea98a&scoped=true&"
import script from "./commerce-setup.vue?vue&type=script&lang=js&"
export * from "./commerce-setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cea98a",
  null
  
)

export default component.exports